export function parseChoiceLines(choicesText: string): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const line of choicesText.split(/\r\n|\n|\r/)) {
    const value = line.trim();
    if (!value || seen.has(value)) continue;
    seen.add(value);
    result.push(value);
  }
  return result;
}

export function joinChoiceLines(values: string[]): string {
  return parseChoiceLines(values.join("\n")).join("\n");
}

export function mergeChoiceLines(
  existing: string[],
  incoming: string,
): string[] {
  const seen = new Set(existing);
  const next = [...existing];
  for (const value of parseChoiceLines(incoming)) {
    if (seen.has(value)) continue;
    seen.add(value);
    next.push(value);
  }
  return next;
}
